import {PageSubContainerSkeleton, TableSkeleton} from "@project/components/feedback";

export function OfferHistoryPending() {
  return (
    <PageSubContainerSkeleton>
      <TableSkeleton columns={6} rows={20} />
    </PageSubContainerSkeleton>
  );
}
